<template>
  <div class="container mx-auto pb-10">
    <div class="flex items-center pt-4 max-w-[1400px] mx-auto">
      <button
        class="px-6 py-3 bg-slate-800 text-white font-medium rounded-lg hover:bg-slate-900 transition-all duration-300 ease-in-out shadow-md hover:shadow-lg ml-auto text-xs"
        @click="goToRegister"
      >
        등록하기
      </button>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-[1400px] mx-auto mt-6">
      <div
        v-for="item in paginatedRows"
        :key="item.insight_id"
        @click="handleRowClick(item)"
        class="bg-white rounded-lg shadow-md p-5 cursor-pointer hover:shadow-lg transition h-[350px] flex flex-col"
      >
        <!-- 이미지 고정 영역 -->
        <div class="w-full h-36 rounded mb-3 overflow-hidden bg-gray-100 flex items-center justify-center">
          <img
            :src="extractFirstImage(item.content)"
            alt="썸네일"
            class="object-cover w-full h-full"
            v-if="extractFirstImage(item.content)"
          />
        </div>

        <!-- 텍스트 영역 (유동 길이) -->
        <div class="flex flex-col justify-start flex-grow">
          <h3 class="text-lg font-semibold text-gray-800 mb-1 text-left line-clamp-2">
            {{ item.title }}
          </h3> 
          <p class="text-sm text-gray-500 text-left mt-1 line-clamp-2">
            {{ stripHtml(item.content) }}
          </p>
          <p class="text-sm text-gray-500 text-left mt-1">작성자 : {{ item.user_nm }}</p>
        </div>
      </div>


    </div>

    <!-- Pagination -->
    <div class="flex justify-center mt-8 space-x-2">
      <button
        class="px-3 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300"
        :disabled="page === 1"
        @click="page--"
      >
        이전
      </button>
      <button
        class="px-3 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300"
        :disabled="page === pagination.lastPage"
        @click="page++"
      >
        다음
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

const router = useRouter()
const page = ref(1)
const perPage = 9
const rows = ref([])

const store = useStore()
async function handleSearch() {
  await store.dispatch('insight/fetchInsightList')
  const res = store.getters['insight/allInsightlistlist']
  rows.value = res
}
handleSearch()

const pagination = computed(() => {
  const last = Math.ceil(rows.value.length / perPage)
  return { page: page.value, perPage, lastPage: last }
})

const paginatedRows = computed(() => {
  const start = (page.value - 1) * perPage
  return rows.value.slice(start, start + perPage)
})

function goToRegister() {
  router.push('/pub/insight/register')
}

function handleRowClick(row) {
  router.push({ name: 'INSIGHTDetail', params: { insight_id: row.insight_id } })
}

function extractFirstImage(html) {
  const match = html?.match(/<img[^>]+src="([^">]+)"/i)
  return match ? match[1] : null
}

function stripHtml(html) {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
}

</script>
